import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClientsService {

  private _clientsapiUrl = `${environment.travel}/clients`;
  private _travelapiUrl = `${environment.travel}`;

  constructor(
    private _http: HttpClient
  ) { }

  getAllClients(pageNumber:any, pageSize:any, token:any, searchValue:any, filters : any ):Observable<any>{
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 20,
      search: searchValue,
      filters: filters
    }
    return this._http.post<any>(`${this._clientsapiUrl}`, paginationSettings)
  }

  deleteClient(clientId: any){
    return this._http.delete<any>(`${this._clientsapiUrl}/client/${clientId}`)
  }

  getClient(clientId: any): Observable<any>{
    return this._http.get<any>(`${this._clientsapiUrl}/client/${clientId}`)
  }

  updateClient(clientId: any, formData: any):Observable<any>{
    return this._http.put<any>(`${this._clientsapiUrl}/client/${clientId}`, formData)
  }

  getClientFromPhoneNumber(phoneNumber:any):Observable<any>{
    return this._http.post<any>(`${this._travelapiUrl}/clientdetails?phone=${phoneNumber}`, {} )
  }

  performBulkActions(req:any): Observable<any>{
    return this._http.put<any>(`${this._travelapiUrl}/updateclients`, req)
  }
}
